// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/settings/organization-locations/archive',
        component: () =>
            import('@/pages/[organisation]/settings/organization-locations/archive.vue'),
        name: 'settings.organization-locations.archived-organization-locations',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.location.update-organization-location',
        },
    },
    {
        path: '/:organisation/settings/organization-locations/archive/:id',
        component: () =>
            import('@/pages/[organisation]/settings/organization-locations/archive/[id].vue'),
        name: 'settings.organization-locations.view-archived-organization-location',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.location.update-organization-location',
        },
    },
    {
        path: '/:organisation/settings/organization-locations',
        component: () =>
            import('@/pages/[organisation]/settings/organization-locations.vue'),
        name: 'settings.organization-locations.search-organization-locations',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.location.view-organization-locations',
        },
    },
    {
        path: '/:organisation/settings/organization-locations/new',
        component: () =>
            import('@/pages/[organisation]/settings/organization-locations/new.vue'),
        name: 'settings.organization-locations.create-organization-location',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.location.create-organization-location',
        },
    },
    {
        path: '/:organisation/settings/organization-locations/:id',
        component: () =>
            import('@/pages/[organisation]/settings/organization-locations/[id].vue'),
        name: 'settings.organization-locations.view-organization-location',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.location.view-organization-locations',
        },
    },
    {
        path: '/:organisation/settings/organization-locations/:id/edit',
        component: () =>
            import('@/pages/[organisation]/settings/organization-locations/[id]/edit.vue'),
        name: 'settings.organization-locations.update-organization-location',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.location.update-organization-location',
        },
    },
];
